/**
 * @module JobSearchAssistance
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import AvailableJobsMessage from './AvailableJobsMessage';
import NoAvailableJobsMessage from './NoAvailableJobsMessage';
import { STRINGS } from '../helpers/strings';

/**
 * Represents the section that informs about the jobs search result.
 *
 * @param {object} props - The component props object.
 * @param {number} [props.jobsCount] - The number of jobs.
 * @param {string} [props.messageToShow] - The string value for the message to show. This value can be: 'default' (the default), 'available' and 'no-available'.
 * When invalid values is passed in the 'default' logic for the message will be used.
 *
 * @returns {React.ReactElement} The JobSearchAssistance component.
 */
export default function JobSearchAssistance({
  jobsCount = 0,
  messageToShow = STRINGS.messages.default,
}) {
  const validMessagesToShow = {
    available: {
      content: <AvailableJobsMessage />,
    },
    default: {
      content:
        jobsCount > 0 ? <AvailableJobsMessage /> : <NoAvailableJobsMessage />,
    },
    'no-available': {
      content: <NoAvailableJobsMessage />,
    },
  };

  const message =
    validMessagesToShow[messageToShow]?.content ||
    validMessagesToShow.default.content;

  return (
    <div
      className="job-search-assistance text-center"
      data-testid="lc-job-search-assistance"
    >
      {message}
    </div>
  );
}
